@for (option of primaryOptions; track option) {
    <label [class.selected]="option.value === control.value">
        {{ option.label }}
        <input type="radio"
               [formControl]="control"
               [value]="option.value"></label>
}
@if (additionalOptions.length > 0) {
    <label class="menu-trigger"
           [class.selected]="additionalOptionSelected"
           [matMenuTriggerFor]="dropdownButton">
        <ng-container i18n="@@component.tab-bar-content.more">
            Weitere
        </ng-container>
        <app-icon name="chevron_down" />
    </label>
    <mat-menu #dropdownButton="matMenu" xPosition="after" yPosition="below">
        @for (option of additionalOptions; track option) {
            <label class="menu-item"
                   [class.selected]="option.value === control.value">
                {{ option.label }}
                <input type="radio" [formControl]="control" [value]="option.value">
            </label>
        }
    </mat-menu>
}
